<h2 mat-dialog-title>{{'Chatbot' | camelCase}}</h2>
<button mat-button class="close-icon" [mat-dialog-close]="true">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content class="mat-typography" #dialogContent>
  <div id="chatWindow">
    <div class="message-container">
      @for(msg of messages;track idx; let idx = $index ){
      <ng-container>
        @if(msg.question){
        <div class="message question">{{ msg.question }}</div>
        }
        <div class="message answer">
          @switch (msg.type) {
            @case('text'){
            <div>{{ msg.answer }}</div>
            }
             @case('table'){
              @if(msg.tableSchema){
                <app-dynamic-data-table 
                  [DataTableSchema]="msg.tableSchema" class="dynamic-table-main-container"
                  [dataInput]="msg.answer?.data ? msg.answer.data : msg.answer">
                </app-dynamic-data-table>
              }
            }
            @case('chart'){
              @if(msg.chartConfig){
                <app-chart class="chart" [chartSchema]="msg.chartConfig.chartSchema" [chartType]="msg.chartConfig.chartType" [dataInput]="msg.answer"
                  [filterSchema]="msg.chartConfig.filterSchema" [elementId]="msg.chartConfig.elementId" [onLoadFetch]="msg.chartConfig.onLoadFetch"></app-chart>
              }
            }
            @case('download'){
              <span class="attachment-value " style="display: block" (click)="downloadFile(msg.answer)"
                onkeypress="" >{{msg.answer?.['displayName'] | camelCase}}<span class="fa-solid fa-download" style="padding: 0 0.5rem;"></span></span>
            }
            @default{
              @if(msg.answer) {
                <div>{{ msg.answer }}</div>
              } @else if(chatLoader) {
                <div class="typing-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              }
            }
        }
        </div>
        @if(msg.showSuggestion && msg.suggestedQuestions && msg.suggestedQuestions.length > 0){
        <div class="suggestion-container mt-3">
          <div class="suggestion-header">Please select below options:</div>
          <div class="suggestions-list">
            @for(suggestion of msg.suggestedQuestions; track suggestion){
              <div class="message suggestion" (click)="onSuggestionClick(suggestion)">{{ suggestion }}</div>
            }
          </div>
        </div>
        }
      </ng-container>
    }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="input-area">
    <input type="text" [(ngModel)]="question" (keyup.enter)="submitQuestion()" [disabled]="chatLoader" placeholder="Type a message"/>
    <mat-icon class="send-icon" (click)="submitQuestion()" [class.disabled]="chatLoader">send</mat-icon>
  </div>
</mat-dialog-actions>
